import { render, staticRenderFns } from "./buildingSystem.vue?vue&type=template&id=4b723c4b&scoped=true"
import script from "./buildingSystem.vue?vue&type=script&lang=js"
export * from "./buildingSystem.vue?vue&type=script&lang=js"
import style0 from "./buildingSystem.vue?vue&type=style&index=0&id=4b723c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b723c4b",
  null
  
)

export default component.exports